import React from "react";

export default function AgruparModal() {
  return (
    <div
      className="modal fade"
      id="agrupar-modal"
      tabIndex="-1"
      aria-labelledby="modalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h4>Confirmação de agrupamento de pacientes</h4>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
            />
          </div>

          <div className="modal-body">
            <p>Você confirma o agrupamento dos pacientes abaixo?</p>

            <div className="table-responsive">
              <table className="table text-nowrap table-hover">
                <thead>
                  <tr>
                    <th scope="">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          defaultValue=""
                          id="flexCheckDefault"
                        />
                      </div>
                    </th>
                    <th scope="col">Nome</th>
                    <th scope="col">Nome da mãe</th>
                    <th scope="col">Data de nascimento</th>
                    <th scope="col">Endereço</th>
                    <th scope="col">CPF</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          defaultValue=""
                          id="flexCheckDefault"
                        />
                      </div>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="modal-footer d-grid gap-2 d-md-flex justify-content-md-end">
            <button
              className="btn btn-cancel me-md-2"
              type="button"
              data-bs-dismiss="modal"
            >
              Cancelar
            </button>
            <button className="btn btn-submit" type="button">
              Confirmar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
